module.exports = __webpack_public_path__ + "img/Lato-Hairline.4be9b589.svg";